import { keepPreviousData, queryOptions } from '@tanstack/react-query';
import handle401 from '../handle-401';
import HttpClient from '../../Api/HttpClient';

function transformAPIFlowToUI(flow) {
  let defaultAssignee = null;
  if (flow.internal_assignee_details) {
    defaultAssignee = flow.internal_assignee_details.id;
  } else if (flow.template_owner_assigned) {
    defaultAssignee = 'project_owner';
  } else {
    defaultAssignee = 'unassigned';
  }

  return {
    id: flow.id,
    label: flow.custom_label,
    normalisedLabel: flow.normalised_label,
    department: flow.department,
    active: flow.active,
    color: flow.color,
    appliesTo: flow.applies_to,
    isLegalType: flow.is_legal,
    lastCompletionTime: flow.last_completion_time,
    last5AvgCompletionTime: flow.last5_avg_completion_time,
    weight: flow.weight,
    clientVisible: flow.client_visible,
    templateOwnerAssigned: flow.template_owner_assigned,
    internalAssignee: flow.internal_assignee_details
      ? {
          id: flow.internal_assignee_details.id,
          firstName: flow.internal_assignee_details.first_name,
          lastName: flow.internal_assignee_details.last_name,
          avatarUrl: flow.internal_assignee_details.avatar,
          email: flow.internal_assignee_details.email,
          role: flow.internal_assignee_details.role,
          phoneNumber: flow.internal_assignee_details.phone_number,
        }
      : null,
    category: flow.category,
    side: flow.side,
    duration: flow.duration,
    stepsCount: flow.nb_steps,
    docsCount: flow.nb_docs,
    rushDuration: flow.rush_duration,
    notifyOnCreation: flow.notify_on_creation,
    defaultAssignee,
    description: flow.description,
    internalNote: flow.internal_note,
  };
}

export const flowsListQuery = () =>
  queryOptions({
    gcTime: 1000 * 60 * 5,
    staleTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
    queryKey: ['flows-list'],
    queryFn: handle401(async () => {
      const { data } = await HttpClient.getDocumentsType();

      return data.map((flow) => transformAPIFlowToUI(flow));
    }),
  });

export const flowQuery = ({ flowId }) =>
  queryOptions({
    queryKey: ['flow', flowId],
    queryFn: handle401(async () => {
      const { data } = await HttpClient.singleDocumentsType({ id: flowId });
      const flow = data[0];

      return transformAPIFlowToUI(flow);
    }),
  });
